import React from "react"
import PropTypes from "prop-types"

import LexSchedule from './LexSchedule';
import StandardButton from '../app_components/StandardButton'
import TopicsContainer from '../exchanges_sections/TopicsContainer'
import MeetingTopics from './MeetingTopics'
import Icon from '../app_components/Icon'

class ScheduleLexTopics extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit",
      lang_one: '',
      lang_two: '',
      currentUserLanguage: '',
      selected: '',
      chooseActivities: false,
      meeting: ''
    }

    this.changeSelect = this.changeSelect.bind(this)
    this.toggleActivities = this.toggleActivities.bind(this)
    this.renderMeetingTopics = this.renderMeetingTopics.bind(this)
  }

  deriveUserSettings(meeting, languages, currentUser) {
    const currentUserLanguage = languages.includes(meeting.lang_one_id) ? 1 : 2
    const isRequestor = meeting.requestor_id === currentUser.id

    return {
      currentUserLanguage,
      selected: currentUserLanguage,
      otherUser: isRequestor ? meeting.requestee : meeting.requestor,
      currentUser: isRequestor ? meeting.requestor : meeting.requestee
    }
  }


  componentDidMount() {
    $.ajax({
      url: `../schedule_lex_topics`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        meeting_id: this.props.meetingId
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        const { meeting, languages, current_user } = data.data

        this.setState({
          languages,
          current_user,
          topics: data.data.topics,
          meeting,
          lang_one: data.data.lang_one,
          lang_two: data.data.lang_two,
          ...this.deriveUserSettings(meeting, languages, current_user)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  componentWillUnmount() {
    this.setState({
      chooseActivities: false
    })
  }


  changeSelect(n) {
    this.setState({
      selected: n
    })
  }

  toggleActivities() {
    this.setState({
      chooseActivities: !this.state.chooseActivities
    })
  }

  renderMeetingTopics() {
    if(this.state.selected === 1) {
      return(<MeetingTopics isCurrentUser={this.state.currentUserLanguage === this.state.selected} meetingId={this.state.meeting.id} userId={(this.state.currentUserLanguage === 1) ? this.state.currentUser.id : this.state.otherUser.id}/>)
    } else if(this.state.selected === 2) {
      return(<MeetingTopics isCurrentUser={this.state.currentUserLanguage === this.state.selected} meetingId={this.state.meeting.id} userId={(this.state.currentUserLanguage === 2) ? this.state.currentUser.id : this.state.otherUser.id}/>)
    }
    return null
  }

  renderBackButton() {
    return(
      <button
        type="button"
        className="lexSchedulePage__backBtn"
        onClick={() => this.toggleActivities()}
      >
        <Icon name="arrow-left" size={18} color="#1E6FD9" />
        <span className="lexSchedulePage__backLabel">Back to Meeting</span>
      </button>
    )
  }

  render() {
    if(this.state.chooseActivities === true) {
      return(
        <div className="lexSchedulePage lexSchedulePage--activities">
          {this.renderBackButton()}
          <TopicsContainer searchLottie={this.props.searchLottie} favoriteStarLottie={this.props.favoriteStarLottie} meetingId={this.state.meeting.id}/>
        </div>
      )
    }
    if(this.state.meeting && this.state.otherUser) {
    return(
      <div className="lexSchedulePage">
        <div className="lexSchedulePage__panel">
          <header className="lexSchedulePage__header">
            <span className="lexSchedulePage__iconCircle" aria-hidden="true">
              <Icon name="schedule" size={20} color="#494CE9" />
            </span>
            <h1 className="lexSchedulePage__title">Lex Schedule</h1>
          </header>
          <p className="lexSchedulePage__subtitle">Tap a half to see planned activities for that language</p>

          <LexSchedule
            meeting={this.state.meeting}
            lang_one={this.state.lang_one}
            lang_two={this.state.lang_two}
            selected={this.state.selected}
            changeSelect={this.changeSelect}
            otherUser={this.state.otherUser}
            currentUser={this.state.currentUser}
            currentUserLanguage={this.state.currentUserLanguage}
          />
        </div>

        {this.renderMeetingTopics()}

        {(this.state.selected === this.state.currentUserLanguage) &&
          <div className="lexSchedulePage__cta">
            <StandardButton
              size={'large'}
              primary={true}
              onClick={this.toggleActivities}
              text="Add activities"/>
          </div>
          }
      </div>
    )
    }
    return null
  }

}

export default ScheduleLexTopics;
